import React, { Component } from "react";
import styled from "styled-components";
import Panel from "../common/Panel";
import AddButtonRaw from "../common/AddButton";
import AddTemplateModals from "./AddTemplateModals";
import List from "./ListWithQuery";

export default class TemplateReplyPanel extends Component {
  state = {
    showModal: false
  };
  render() {
    return (
      <Panel title="TEMPLATE REPLY">
        <AddButton onClick={this.showModal}> + Add New Template</AddButton>
        <ListTemplate>
          <List />
          {this.state.showModal && (
            <AddTemplateModals
              text="Add New Template"
              onCancel={this.hideModal}
              onConfirm={this.hideModal}
            />
          )}
        </ListTemplate>
      </Panel>
    );
  }
  hideModal = () => {
    this.setState({ showModal: false });
  };
  showModal = () => {
    this.setState({ showModal: true });
  };
}

const AddButton = styled(AddButtonRaw)`
  margin-top: 10px;
  margin-bottom: 16px;
`;

const ListTemplate = styled.div``;



// WEBPACK FOOTER //
// ./src/module-supervisor-setting/template-reply/TemplateReplyPanel.js